import { NavLink, Outlet } from "react-router-dom";
import { useSession } from "../state/session";
import { Logo } from "./Logo";

/** Nawigacja dashboardu wg §23 — kolejność odpowiada temu, jak często się z niej korzysta. */
const SECTIONS = [
  { to: "/", key: "nav.overview", end: true },
  { to: "/cues", key: "nav.attentionCenter", end: false },
  { to: "/contracts", key: "nav.contracts", end: false },
  { to: "/documents", key: "nav.documents", end: false },
  { to: "/timeline", key: "nav.timeline", end: false },
  { to: "/ask", key: "nav.ask", end: false },
  { to: "/connections", key: "nav.connections", end: false },
  { to: "/company", key: "nav.company", end: false },
  { to: "/settings", key: "nav.settings", end: false },
] as const;

export function Layout() {
  const { translator, organization, organizations, selectOrganization, signOut, user } = useSession();
  const { t } = translator;

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="sidebar__brand">
          <Logo size={26} />
          <span>{t("common.appName")}</span>
        </div>

        {organizations.length > 1 && (
          <div className="field">
            <label htmlFor="org">{t("nav.company")}</label>
            <select
              id="org"
              value={organization?.id ?? ""}
              onChange={(event) => selectOrganization(event.target.value)}
            >
              {organizations.map((org) => (
                <option key={org.id} value={org.id}>
                  {org.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <nav className="sidebar__nav">
          {SECTIONS.map((section) => (
            <NavLink
              key={section.to}
              to={section.to}
              end={section.end}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {t(section.key)}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar__footer">
          <span>{user?.email}</span>
          <button className="btn btn--ghost btn--small" type="button" onClick={() => void signOut()}>
            {t("auth.signOut")}
          </button>
        </div>
      </aside>

      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
